export default __webpack_public_path__ + "static/media/email-blue.5df0117b.svg";